import moment from "moment";
import { PermissaoUsuario } from "./PermissaoUsuario";
import { PermissaoUsuarioTransacao } from "./PermissaoUsuarioTransacao";
import { MBase } from "./MBase";

export class Usuario extends MBase {
    Id: number;
    PessoaId: number;
    EmpresaId: number;
    Nome:string = "";
    Email:string = "";
    Telefone:string = "";
    Whatsapp:string = "";
    Login:string = "";
    Senha:string = "";
    SenhaDecript:string = "";
    Perfil: number = 0;
    PerfilInt:number = 0;
    isSuper: boolean;
    IsFornecedor: boolean;
    Ativo: boolean;
    FazendaId: number;
    SincronizaEstoqueERP: boolean;
    IdUsuarioERP:string = "";
    LoginUsuarioERP:string = "";
    LeuRelease: boolean;
    TokenTemporario:string = "";
    ExpiracaoToken:Date;
    TokenAcesso:string = "";
    SenhaAntiga:string = "";
    DataNascimento:string;
    Imagem:string = "";
    PermissaoUsuario: PermissaoUsuario = new PermissaoUsuario();
    permissaoUsuarioTransacaos: PermissaoUsuarioTransacao[];
    ModuloPadrao: number = 0;
    Idioma:string = "";

     get dataAlteracaoStr(): string{
        return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
     }

     get descStatus(): string{
      if(this.Ativo && this.TokenTemporario){
        return 'Pendente'
      } else if(this.Ativo ){
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    }
}

export class RedefinirSenha{
  NovaSenha:string = "";
  UsuarioId: number;
  SenhaAtual:string = "";
  ConfirmNovaSenha:string = "";
}

export enum enumPerfil
{
    NaoLogado = 0,
    Super = 1,
    Admin = 2,
    Usuario = 3,
    Fornecedor = 4,
    Fornecedor_Usuario = 5,
    Parceiro = 6,
    ConsultorAdministrador = 7,
    Consultor = 8
}
export enum enumPerfil_old
{
    Super = 1,
    Admin = 2,
    Usuario = 3,
    Master = 4
}


